import Vue from "vue"
import vueRouter from "@/router/index.js"
import {Toast} from "vant";
import axios from "axios";
import qs from "qs";
import {clearLocalStorage, getCookie} from "@/utils/storage.js";
import wx from "weixin-js-sdk";

// 判断是否在微信小程序环境
function isInWechatMiniProgram() {
    return window.__wxjs_environment === 'miniprogram';
}

axios.defaults.transformRequest = [
    function (data) {
        return qs.stringify(data);
    }
];

// 路由拦截
axios.interceptors.request.use(function (config) {
    config.headers["Authorization"] = `Bearer ${getCookie("token")}`;
    // 如果不是商品接口/订单列表才给全局loading
    if (config.method == "get") {
        if (config.url.indexOf("/goods/list") == -1 && config.url.indexOf("/orders") == -1 && config.url.indexOf("/customers") == -1) {
            Vue.$loading.show()
        }
    } else {
        Vue.$loading.show()
    }
    return config;
}, function (error) {
    // 请求配置错误时也要隐藏loading
    Vue.$loading.hide()
    return Promise.reject(error);
});

axios.interceptors.response.use(
    response => {
        Vue.$loading.hide()
        return response;
    },
    error => {
        if (error.response.data.code === -2) {
            Toast.fail({
                message: "请重新登录",
                onClose() {
                    clearLocalStorage("userData")
                    // 检查是否在小程序环境
                    if (isInWechatMiniProgram()) {
                        // 在小程序环境中，直接跳转到login页面
                        wx.miniProgram.navigateTo({
                            url: "/pages/login/index"
                        });
                    } else {
                        // 在浏览器环境中，使用H5路由跳转
                        vueRouter.push({name: "Login"});
                    }
                }
            });
        }
        Vue.$loading.hide()
        return Promise.reject(error.response.data)
    });

// 请求封装
export function post(url, params, callback) {
    axios({
        method: "post",
        url: url,
        data: params,
    }).then(res => {
        callback(res);
    });
}

export function del(url, params, callback) {
    axios({
        method: "delete",
        url: url,
        params: params,
    }).then(res => {
        callback(res);
    });
}

export function get(url, params, callback) {
    axios({
        method: "get",
        url: url,
        params: params,
    }).then(res => {
        callback(res);
    });
}